import { useAuth } from '@commander/auth';
import { useRealtimeNotifications } from '@commander/notifications';
import { PUSHER_CHANNELS, PUSHER_EVENTS, usePusher } from '@commander/utils';

/**
 * Subscribes the shell app to real-time notification events so counts/lists
 * stay in sync without manual refresh or polling delays.
 */
export function RealtimeNotificationsProvider() {
  const { user } = useAuth();
  const { subscribe, unsubscribe } = usePusher();

  useRealtimeNotifications({
    userId: user?.id || '',
    channelName: user?.id ? PUSHER_CHANNELS.USER(user.id) : '',
    events: [
      PUSHER_EVENTS.NOTIFICATION_EMAIL_RECEIVED,
      PUSHER_EVENTS.NOTIFICATION_SMS_RECEIVED,
      PUSHER_EVENTS.NOTIFICATION_TASK_ASSIGNED,
      PUSHER_EVENTS.NOTIFICATION_SEQUENCE_NOTIFY,
      PUSHER_EVENTS.NOTIFICATION_SIGNAL_ALERT,
    ],
    pusherHooks: { subscribe, unsubscribe },
  });

  return null;
}
